import { TableName } from "../../../tables"
import { HoardOrder, SaleOperation, SaleOrder } from "../state/types"
import { useHoardActions } from "./hoardActions"
import { useSaleActions } from "./saleActions"

export const useSaleOperationActions = () => {
    const { saveSale } = useSaleActions()
    const { saveHoard } = useHoardActions()

    const saveSaleOperation = (
        table: TableName,
        operation: SaleOperation
    ): Promise<SaleOperation> => {
        if (table === TableName.SALE_ORDERS) {
            return saveSale(operation as SaleOrder)
        } else {
            return saveHoard(operation as HoardOrder)
        }
    }
    
    return {
        saveSaleOperation
    }
}
